import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Router } from '@angular/router';

@Component({
  selector: 'app-all-services',
  templateUrl: './all-services.page.html',
  styleUrls: ['./all-services.page.scss'],
})
export class AllServicesPage implements OnInit {

  constructor(private router: Router, private modalController: ModalController) { }

  ngOnInit() {
  }

  /* Routes and navigation starts */

  // Dismiss modal
  dismiss() {
    this.modalController.dismiss()
  }

  // Go to withdraw loan
  goToWithdrawLoan() {
    this.dismiss();
    this.router.navigate(['/withdraw-loan'])
  }

  /* Routes and navigation ends */

}
